import React, { useState, useEffect } from "react";
import { AiOutlineEdit, AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
// import moment from 'moment';
import { Drawer, Button, Form, Row, Col, Select, message, Switch } from "antd";
import { SelectChief } from "./SelectChief";
import { SelectCustomer } from "./SelectCustomer";
import FormListTeam from "./FormListTeam";
import { FaChartLine } from "react-icons/fa";

import axios from "axios";
import { compressImage } from "../../own-comp";
import "../styles/Report.css";

const { Option } = Select;

export default function EditReport({ setSuccess, id, reports }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startImage, setStartImage] = useState(null);
  const [resultImage, setResultImage] = useState(null);
  const [report, setReport] = useState({});
  const [form] = Form.useForm();
  const [isMobile, setIsMobile] = useState(false);

  const [hasElectricianPlumber, setHasElectricianPlumber] = useState("0");
  const [hasCeilBuilder, setHasCeilBuilder] = useState("0");
  const [hasBlackSmith, setHasBlackSmith] = useState("0");
  const [hasAirConditionerMan, setHasAirConditionerMan] = useState("0");
  const [hasMirrorBuilder, setHasMirrorBuilder] = useState("0");
  const [hasCarpenter, setHasCarpenter] = useState("0");

  const handleResize = () => {
    // 960
    if (window.innerWidth <= 960) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
  }, []);

  window.addEventListener("resize", handleResize);

  useEffect(() => {
    if (reports) {
      form.setFieldsValue({
        userId: reports?.userId,
      });
    }
    if (report && visible) {
      form.setFieldsValue({
        customerId: report?.customerId,
        status: report?.status,
        team: report?.team?.map((e) => ({
          ...e,
          isContract: parseInt(e?.isContract, 10) > 0 ? true : false,
          isDone: parseInt(e?.isDone, 10) > 0 ? true : false,
        })),
        team_tmr: report?.team_tmr?.map((e) => ({
          ...e,
          isContract: parseInt(e?.isContract, 10) > 0 ? true : false,
        })),
        challenges: report?.challenges,
        femaleWorkerCount: parseInt(report?.femaleWorkerCount),
        painterCount: parseInt(report?.painterCount),
        femaleWorkerCountTmr: parseInt(report?.femaleWorkerCountTmr),
        builderCountTmr: parseInt(report?.builderCountTmr),
        painterCountTmr: parseInt(report?.painterCountTmr),
        workerCountTmr: parseInt(report?.workerCountTmr),
      });

      setHasElectricianPlumber(report?.hasElectricianPlumber);
      setHasCeilBuilder(report?.hasCeilBuilder);
      setHasBlackSmith(report?.hasBlackSmith);
      setHasAirConditionerMan(report?.hasAirConditionerMan);
      setHasMirrorBuilder(report?.hasMirrorBuilder);
      setHasCarpenter(report?.hasCarpenter);
    }
    getConstructById(id);
  }, [visible]);

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const onFinish = (val) => {
    if (val.team.length <= 0) {
      message.error("សូមបញ្ជូលក្រុម!!");
      return;
    }
    setLoading(true);

    updateDailyConstruct({
      ...val,
      userId: val?.userId,
      resultImage,
      startImage,
      dc_id: id,
      hasElectricianPlumber: hasElectricianPlumber,
      hasCeilBuilder: hasCeilBuilder,
      hasBlackSmith: hasBlackSmith,
      hasAirConditionerMan: hasAirConditionerMan,
      hasMirrorBuilder: hasMirrorBuilder,
      hasCarpenter: hasCarpenter,
      team: val?.team?.map((e) => ({
        ...e,
        isContract: e?.isContract ? 1 : 0,
        isDone: e?.isDone ? 1 : 0,
      })),
      team_tmr: val?.team_tmr?.map((e) => ({
        ...e,
        isContract: e?.isContract ? 1 : 0,
      })),
    });
  };

  const updateDailyConstruct = async (data) => {
    const params = new FormData();
    params.append("db_user", process.env.React_App_DB_USER);
    params.append("db_password", process.env.React_App_DB_PASSWORD);
    params.append("db", process.env.React_App_DB);

    params.append("data", JSON.stringify(data));
    params.append("resultImage", data?.resultImage);
    params.append("startImage", data?.startImage);

    return await axios
      .post(
        `${process.env.React_App_URL}/update/updateDailyConstructByIdAdmin.php`,
        params,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then(async function (response) {
        if (
          response?.data !== "error" &&
          response?.data !== "errorsize" &&
          response?.data !== "errorextension"
        ) {
          onClose();
          message.success("កែប្រែបាយការណ៍ជោគជ័យ!!");
          form.resetFields();
          setResultImage(null);
          setStartImage(null);
          setLoading(false);
          setSuccess(true);
        } else {
          message.error("មានបញ្ហា!!");
        }
      });
  };

  const setConstructionCustomer = (e) => {
    form.setFieldsValue({
      customerId: e,
    });
  };
  const setChief = (e) => {
    form.setFieldsValue({
      userId: e,
    });
  };
  const getConstructById = async (id) => {
    const params = new URLSearchParams();
    params.append("db_user", process.env.React_App_DB_USER);
    params.append("db_password", process.env.React_App_DB_PASSWORD);
    params.append("db", process.env.React_App_DB);
    params.append("data", JSON.stringify({ dc_id: id }));

    return await axios
      .post(
        `${process.env.React_App_URL}/get/getDailyConstructById.php`,
        params,
      )
      .then(async function (response) {
        if (
          (await response?.data) !== "Cannot select" &&
          (await response?.data) !== "notuser"
        ) {
          setReport(response?.data);
          setLoading(false);
          setSuccess(false);
          return response?.data;
        } else {
          setLoading(false);
          return [];
        }
      });
  };

  const handleSetFemaleWorkerCount = (e) => {
    let workerCount = 0;
    let team = form.getFieldValue("team");

    team?.map((t) => {
      workerCount += isNaN(parseInt(t?.workerCount))
        ? 0
        : parseInt(t?.workerCount);
    });

    if (e > workerCount) {
      message.warning("មិនអាចមានកម្មករស្រីច្រើនជាងចំនួនកម្មករទាំងអស់ទេ!!");
      form.setFieldsValue({
        femaleWorkerCount: report?.femaleWorkerCount,
      });
    }
  };

  const handleSetPainterCount = (e) => {
    let builderCount = 0;
    let team = form.getFieldValue("team");

    team?.map((t) => {
      builderCount += isNaN(parseInt(t?.builderCount))
        ? 0
        : parseInt(t?.builderCount);
    });

    if (e > builderCount) {
      message.warning("មិនអាចមានជាងថ្នាំច្រើនជាងចំនួនជាងទាំងអស់ទេ!!");
      form.setFieldsValue({
        painterCount: report?.painterCount,
      });
      return;
    }
  };

  const onSelectStartImage = async (e) => {
    let imageFile = e.target.files[0];
    if (imageFile?.type?.split("/")[0] === "image") {
      setStartImage(await compressImage(imageFile));
    } else {
      message.error("មិនមែនជា File រូបភាពទេ!!");
    }
  };

  const onSelectResultImage = async (e) => {
    let imageFile = e.target.files[0];
    if (imageFile?.type?.split("/")[0] === "image") {
      setResultImage(await compressImage(imageFile));
    } else {
      message.error("មិនមែនជា File រូបភាពទេ!!");
    }
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={showDrawer}
        shape="circle"
        icon={<AiOutlineEdit />}
        size="middle"
        style={{ paddingTop: 5 }}
      />
      <Drawer
        title="កែប្រែបាយការណ៍"
        placement="right"
        width={isMobile ? "100%" : 736}
        onClose={onClose}
        visible={visible}
      >
        <Form
          encType="multipart/form-data"
          form={form}
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={10}>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <Form.Item
                // label="ឈ្មោះការដ្ឋាន"
                name="userId"
                rules={[{ required: true, message: "ទាមទារបំពេញ" }]}
              >
                <SelectChief title={"មេការ"} setValue={setChief} />
              </Form.Item>
            </Col>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <Form.Item
                // label="ឈ្មោះការដ្ឋាន"
                name="customerId"
                rules={[{ required: true, message: "ទាមទារបំពេញ" }]}
              >
                <SelectCustomer
                  title={"ឈ្មោះការដ្ឋាន"}
                  setValue={setConstructionCustomer}
                />
              </Form.Item>
            </Col>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <Form.Item
                // label="ជ្រើសរើសដំណាក់កាល"
                name="status"
                rules={[{ required: true, message: "ទាមទារបំពេញ" }]}
              >
                <Select
                  placeholder="ជ្រើសរើសដំណាក់កាល"
                  size="large"
                  style={{ width: "100%" }}
                >
                  <Option value="រុះរើសំណង់ចាស់">រុះរើសំណង់ចាស់</Option>
                  <Option value="ការងារទ្រួសត្រាយដី">ការងារទ្រួសត្រាយដី</Option>
                  <Option value="ការងារវាស់វែង">ការងារវាស់វែង</Option>
                  <Option value="រកកែងនៅទីតាំងផ្ទាល់ដី">
                    រកកែងនៅទីតាំងផ្ទាល់ដី
                  </Option>
                  <Option value="សំអាតដី">សំអាតដី</Option>
                  <Option value="បុកភ្ជើរ">បុកភ្ជើរ</Option>
                  <Option value="ជីកដីធ្វើគ្រឹះ">ជីកដីធ្វើគ្រឹះ</Option>
                  <Option value="លុបបំពេញរណ្តៅគ្រឹះ">លុបបំពេញរណ្តៅគ្រឹះ</Option>
                  <Option value="ធ្វើធ្នឹមបាតក្រោម">ធ្វើធ្នឹមបាតក្រោម</Option>
                  <Option value="ចាក់ដីលុបបំពេញផ្ទៃអគារ">
                    ចាក់ដីលុបបំពេញផ្ទៃអគារ
                  </Option>
                  <Option value="ធ្វើសសរ">ធ្វើសសរ</Option>
                  <Option value="ធ្វើធ្នឹម">ធ្វើធ្នឹម</Option>
                  <Option value="បង្គប់ទីប">បង្គប់ទីប</Option>
                  <Option value="ចាក់ប្លង់សេ">ចាក់ប្លង់សេ</Option>
                  <Option value="រៀបឥដ្ឋ">រៀបឥដ្ឋ</Option>
                  <Option value="បង្គប់ហ្គែន">បង្គប់ហ្គែន</Option>
                  <Option value="ធ្វើជណ្តើរ">ធ្វើជណ្តើរ</Option>
                  <Option value="បូកនិងសី">បូកនិងសី</Option>
                  <Option value="ធ្វើដំបូល">ធ្វើដំបូល</Option>
                  <Option value="ដាក់ទ្វា">ដាក់ទ្វា</Option>
                  <Option value="ដាក់បង្អួច">ដាក់បង្អួច</Option>
                  <Option value="ក្រាលការ៉ូ">ក្រាលការ៉ូ</Option>
                  <Option value="បំពាក់គ្រឿងបន្ទប់ទឹក">
                    បំពាក់គ្រឿងបន្ទប់ទឹក
                  </Option>
                  <Option value="ចាប់ជ្រីនិងចាប់ជ្រុង">
                    ចាប់ជ្រីនិងចាប់ជ្រុង
                  </Option>
                  <Option value="បៀកថ្នាំ">បៀកថ្នាំ</Option>
                  <Option value="រុញថ្នាំ">រុញថ្នាំ</Option>
                  <Option value="បៀករ៉ង់និងសម្អាត">បៀករ៉ង់និងសម្អាត</Option>
                  <Option value="បំពាក់អំពូល">បំពាក់អំពូល</Option>
                  <Option value="សម្អាត">សម្អាត</Option>
                  <Option value="កែលំអរចំនុចខ្វះខាត">កែលំអរចំនុចខ្វះខាត</Option>
                  <Option value="រួចរាល់">រួចរាល់</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <br />
          <FormListTeam
            report={report?.team}
            name={"team"}
            type="edit"
            addButtonTitle="បន្ថែមក្រុម"
          />

          {/* <Row gutter={10}>
            <Col xs={12}>
              <Form.Item
                name="femaleWorkerCount"
                rules={[{ required: true, message: "ទាមទារបំពេញ" }]}
              >
                <InputNumber
                  placeholder="ចំ.កម្មករស្រី"
                  onStep={(e) => handleSetFemaleWorkerCount(e)}
                  min={0}
                  onKeyUp={(e) => handleSetFemaleWorkerCount(e.target.value)}
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col xs={12}>
              <Form.Item
                // label="ជ្រើសរើសដំណាក់កាល"
                name="painterCount"
                rules={[{ required: true, message: "ទាមទារបំពេញ" }]}
              >
                <InputNumber
                  placeholder="ចំ.ជាងថ្នាំ"
                  min={0}
                  onStep={(e) => handleSetPainterCount(e)}
                  onKeyUp={(e) => handleSetPainterCount(e.target.value)}
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row> */}

          <Row gutter={10}>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasElectricianPlumber"
                // label="ជាងទឹកភ្លើង"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasElectricianPlumber(
                      hasElectricianPlumber === "1" ? "0" : "1",
                    )
                  }
                  checked={hasElectricianPlumber === "1"}
                />
                &emsp;ជាងទឹកភ្លើង
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasCeilBuilder"
                // label="ជាងពិដាន"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasCeilBuilder(hasCeilBuilder === "1" ? "0" : "1")
                  }
                  checked={hasCeilBuilder === "1"}
                />
                &emsp;ជាងពិដាន
              </Form.Item>
            </Col>

            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasBlackSmith"
                // label="ជាងដែក"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasBlackSmith(hasBlackSmith === "1" ? "0" : "1")
                  }
                  checked={hasBlackSmith === "1"}
                />
                &emsp;ជាងដែក
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasAirConditionerMan"
                // label="ជាងម៉ាស៊ីនត្រជាក់"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasAirConditionerMan(
                      hasAirConditionerMan === "1" ? "0" : "1",
                    )
                  }
                  checked={hasAirConditionerMan === "1"}
                />
                &emsp;ជាងម៉ាស៊ីនត្រជាក់
              </Form.Item>
            </Col>

            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasMirrorBuilder"
                // label="ជាងម៉ាស៊ីនត្រជាក់"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasMirrorBuilder(hasMirrorBuilder === "1" ? "0" : "1")
                  }
                  checked={hasMirrorBuilder === "1"}
                />
                &emsp;ជាងកញ្ចក់
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                name="hasCarpenter"
                // label="ជាងម៉ាស៊ីនត្រជាក់"
              >
                <Switch
                  checkedChildren={<AiOutlineCheck />}
                  unCheckedChildren={<AiOutlineClose />}
                  onChange={(e) =>
                    setHasCarpenter(hasCarpenter === "1" ? "0" : "1")
                  }
                  checked={hasCarpenter === "1"}
                />
                &emsp;ជាងឈើ
              </Form.Item>
            </Col>
          </Row>

          {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item name="challenges">
              <TextArea placeholder="តម្រូវការ/បញ្ហា/ផ្សេងៗ" maxLength={100} />
            </Form.Item>
          </Col> */}

          <Row gutter={10}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <p
                style={{
                  marginTop: "13px",
                  fontSize: "18px",
                  // fontFamily: "Bayon",
                  color: "#616161",
                }}
              >
                <FaChartLine /> ការងារថ្ងៃស្អែក៖
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <FormListTeam
                report={report?.team_tmr || []}
                name={"team_tmr"}
                type="create"
                addButtonTitle="បន្ថែមការងារ (ស្អែក)"
              />
            </Col>
          </Row>

          <Form.Item>
            <Button
              type="primary"
              style={{ width: "100%" }}
              loading={loading}
              size="large"
              htmlType="submit"
            >
              កែប្រែ
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}
